import { NgModule } from '@angular/core';

import { SharedLibsModule } from './shared-libs.module';
import { JsonListInputComponent } from './utils/components/json-list-input/json-list-input.component';
@NgModule({
	 
	imports: [
		SharedLibsModule
	],
	exports: [
		SharedLibsModule,
		JsonListInputComponent 
	],
	declarations: [ JsonListInputComponent  ]
})

export class SharedCommonModule { }